import { atom, selector } from 'recoil';
import { getComplexityIndex } from '../utils/complexityCalculator';
import { settingsState } from './settingsState';

const FORM_DATA_KEY = 'complexityIndexFormData';
const ASSESSMENT_KEY = 'complexityIndexAssessment';

export const defaultFormData = {
  units: 'metric',
  location: '',
  residential: false,
  sensitive: false,
  rigCapacity: '',
  reEntry: false,
  Function: '',
  finalHoleDiameter: '',
  numberOfSections: '',
  verticalDepth: 0,
  maxTemperature: 0,
  maxPressure: 0,
  stimulation: false,
  scaling: false,
  corrosion: false,
  circulatingTemp: '',
  pressureRegime: '',
  ubompd: false,
  ucs: '',
  interbedded: false,
  ddi: '',
  multilateral: false,
  interception: false,
  phase: '',
  hydroCarbons: false,
  toxicGas: false
};

const defaultAssessmentState = {
  id: null,
  name: ''
};

// Load from localStorage with fallback
const loadFromStorage = (key, fallback) => {
  try {
    const stored = localStorage.getItem(key);
    if (stored) {
      return { ...fallback, ...JSON.parse(stored) };
    }
  } catch (e) {
    console.warn(`Failed to load ${key} from storage`);
  }
  return fallback;
};

export const formDataState = atom({
  key: 'formDataState',
  default: loadFromStorage(FORM_DATA_KEY, defaultFormData),
  effects: [
    ({ onSet }) => {
      onSet((newValue) => {
        try {
          localStorage.setItem(FORM_DATA_KEY, JSON.stringify(newValue));
        } catch (e) {
          console.warn('Failed to save form data to storage');
        }
      });
    }
  ]
});

export const scoresSelector = selector({
  key: 'scoresSelector',
  get: ({ get }) => {
    const formData = get(formDataState);
    const settings = get(settingsState);
    return getComplexityIndex(formData, settings);
  }
});

// Track when editing an existing saved assessment
export const assessmentState = atom({
  key: 'assessmentState',
  default: loadFromStorage(ASSESSMENT_KEY, defaultAssessmentState),
  effects: [
    ({ onSet }) => {
      onSet((newValue) => {
        try {
          localStorage.setItem(ASSESSMENT_KEY, JSON.stringify(newValue));
        } catch (e) {
          console.warn('Failed to save assessment state to storage');
        }
      });
    }
  ]
});
